/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 70d2f0aa (Mon Feb 23 19:51:14 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { ProgramType } from './'

/**
 *
 * @export
 * @interface CourseOfStudy
 */
export interface CourseOfStudy {
  /**
   *
   * @type ProgramType
   * @memberof CourseOfStudy
   */
  programTypeKey?: ProgramType
  /**
   * The name of the course.
   * @type string
   * @memberof CourseOfStudy
   */
  courseName?: string
  /**
   * A description of the course.
   * @type string
   * @memberof CourseOfStudy
   */
  courseDescription?: string
  /**
   * The amount of credits hours for this course.
   * @type number
   * @memberof CourseOfStudy
   */
  credits?: number
}

export function CourseOfStudyFromJSON(json: any): CourseOfStudy {
  return CourseOfStudyFromJSONTyped(json, false)
}

export function CourseOfStudyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CourseOfStudy {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programTypeKey: !exists(json, 'programTypeKey')
      ? undefined
      : json['programTypeKey'],
    courseName: !exists(json, 'courseName') ? undefined : json['courseName'],
    courseDescription: !exists(json, 'courseDescription')
      ? undefined
      : json['courseDescription'],
    credits: !exists(json, 'credits') ? undefined : json['credits'],
  }
}

export function CourseOfStudyToJSON(value?: CourseOfStudy | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programTypeKey: value.programTypeKey,
    courseName: value.courseName,
    courseDescription: value.courseDescription,
    credits: value.credits,
  }
}
